import React, { useEffect, useState, useContext } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { PlaylistStore } from "../context/ContextProvider";
export default function HamburgerMenu({ color }) {
  const contextStore = useContext(PlaylistStore);
  const { toggleNav, state } = contextStore;
  return (
    <>
      {state.navOpen ? null : (
        <div style={{ padding: "5px 10px", cursor: 'pointer' }} onClick={toggleNav}>
          <GiHamburgerMenu size={30} color={color} />
        </div>
      )}
    </>
  );
}
